module.exports = __webpack_public_path__ + "static/media/a1_parking.af7c3e2a.png";